import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
import { StoreProvider } from '@/providers/StoreProvider'
import { AuthProvider } from '@/providers/AuthProvider'
import { PermissionProvider } from '@/providers/PermissionProvider'
import { AlertProvider } from '@/providers/AlertProvider'
import { ThemeProvider } from '@/context/ThemeContext'
import { ModalProvider } from '@/providers/ModalProvider'
import TenantSubscriptionProvider from '@/components/platform/TenantSubscriptionProvider'
import { ThemeApplier } from '@/components/ThemeApplier'
import { Toaster } from '@/ui/Toast'
import '../../app/globals.css'

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => {
    const { queryClient } = Route.useRouteContext()
    return (
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TenantSubscriptionProvider>
            <StoreProvider>
              <AuthProvider>
                <PermissionProvider>
                  <AlertProvider>
                    <ModalProvider>
                      <ThemeApplier />
                      <Outlet />
                      <Toaster richColors position="top-right" />
                      {import.meta.env.DEV ? <TanStackRouterDevtools /> : null}
                    </ModalProvider>
                  </AlertProvider>
                </PermissionProvider>
              </AuthProvider>
            </StoreProvider>
          </TenantSubscriptionProvider>
        </ThemeProvider>
      </QueryClientProvider>
    )
  },
})
